import { render } from "./OrderSummaryComponent.vue?vue&type=template&id=b7fb71e2"
import script from "./OrderSummaryComponent.vue?vue&type=script&lang=js"
export * from "./OrderSummaryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/OrderSummaryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7fb71e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7fb71e2', __exports__)) {
    api.reload('b7fb71e2', __exports__)
  }
  
  module.hot.accept("./OrderSummaryComponent.vue?vue&type=template&id=b7fb71e2", () => {
    api.rerender('b7fb71e2', render)
  })

}


export default __exports__